
$(window).bind("scroll", function() {
    if ($(this).scrollTop() > 500) { 
      $("#pagetop").addClass('active');
    } else {
      $("#pagetop").removeClass('active');
    }
});

//anchor link
$('a[href^="#"]').on('click', function () {
	smooth(this);
	return false;
});

//pagetop
$('#pagetop').on('click',function () {
	animateoffset(0);
	return false;
});


//smoothScroll
function smooth(target){
	var href = $(target).attr('href');
	var hH = 0;
	var top = $(href).offset().top - hH;
	animateoffset(top);
}
function animateoffset(top){
	$('html,body').animate({scrollTop:top}, 600);
}

//js-scroll
var wH = $(window).height();
var EffectH = wH/6*1;
jQuery(window).on('scroll load', function() {
  var scTop = $(this).scrollTop();
  var scBottom = scTop + $(this).height();
  var effectPos = scBottom - EffectH;
  jQuery('.js-scroll, .js-scroll-delay').each( function() {
    var thisPos = $(this).offset().top;
    if ( thisPos < effectPos ) {
      $.when(
        jQuery(this).addClass("show")
      ).done(function() {
        jQuery(this).delay(250).queue(function(){
            jQuery(this).addClass("done")
        })
      });
    }
  });
});